import { createApp } from 'vue'
import App from './App.vue'
import VueSplide from '@splidejs/vue-splide'

createApp(App).use(VueSplide).mount('#app')
